// Module
var code = "<div class=\"dashboard-single\">\n  <cs-widget v-if=\"widget\" :widget=\"widget\"></cs-widget>\n</div>\n";
// Exports
module.exports = code;